export type InterpolationValues = { [key: string]: string | number | null };

const escapeHTML = (str: string): string => {
	const escapeChars: { [key: string]: string } = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#x27;',
		'/': '&#x2F;'
	};
	return str.replace(/[&<>"'/]/g, match => escapeChars[match]);
};

const regexInterpolation = /{{(.*?)}}/g;
const regexSpaces = /\s+/g;

/**
 * Interpolates a string with values
 * @param {string} string - The string to interpolate
 * @param {InterpolationValues} [values] - The values to interpolate
 * @returns {string} The interpolated string
 */
const interpolate = (string: string, values?: InterpolationValues): string => {
	if (!string) {
		return string;
	}

	if (!values) {
		return string.replace(regexInterpolation, '').replace(regexSpaces, ' ').trim();
	}

	return string
		.replace(regexInterpolation, (_match, placeholder: string) => {
			const variable = placeholder.trim();
			const value = values[variable];

			if (value !== undefined && value !== null) {
				const escapedValue = escapeHTML(String(value));
				return escapedValue;
			}
			return '';
		})
		.replace(regexSpaces, ' ')
		.trim();
};

export default interpolate;
